import addDepositphotosLink from 'helpers/addDepositphotosLink';

const LINK_CLS =
  'tw-text-inherit tw-underline tw-decoration-dotted tw-underline-offset-2 hover:tw-text-primary-700';

// Image attribution required by the Unsplash guidelines (photographer +
// Unsplash links with UTM referral params), the Wikipedia CC BY-SA license
// for imported descriptions, and the Depositphotos partner terms. Every
// page that shows a destination photo renders this — do not remove.
export default function PhotoCredit({ locationDetails, className = '' }) {
  if (!locationDetails) return null;
  const { attribution, unsplashUser, coverAlt, url, license } = locationDetails;
  if (!attribution && !coverAlt && !url) return null;

  return (
    <span className={className}>
      {url && (
        <span>
          Description by{' '}
          <a
            className={LINK_CLS}
            target="_blank"
            rel="nofollow noreferrer noopener"
            href={url}
          >
            Wikipedia
          </a>{' '}
          under{' '}
          <a
            className={LINK_CLS}
            target="_blank"
            rel="nofollow noreferrer noopener"
            href={license}
          >
            CC BY-SA 3.0
          </a>
          {'. '}
        </span>
      )}
      {coverAlt && <span>Cover: {coverAlt}. </span>}
      {attribution && (
        <span>
          Photo:{' '}
          {(unsplashUser && (
            <a
              className={LINK_CLS}
              target="_blank"
              rel="nofollow noreferrer noopener"
              href={`https://unsplash.com/@${unsplashUser}?utm_source=TravelFeed&utm_medium=referral`}
            >
              {attribution}
            </a>
          )) || <span>{addDepositphotosLink(attribution, LINK_CLS)}</span>}
          {unsplashUser && (
            <span>
              {' / '}
              <a
                target="_blank"
                rel="nofollow noreferrer noopener"
                href="https://unsplash.com/?utm_source=TravelFeed&utm_medium=referral"
                className={LINK_CLS}
              >
                Unsplash
              </a>
            </span>
          )}
        </span>
      )}
    </span>
  );
}
